/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeCustomersFromPool} from '../api'

export const useMutationRemoveCustomersFromPool = createReactQueryMutationHook('removeCustomersFromPool', removeCustomersFromPool)
